export const SOCIAL_IMAGE_ALT = "Ishvaram — ईश्वरम. Kundali, Rashifal, Panchang and AI Jyotish.";
/**
 * The same card's alt on /hi/ pages, in Devanagari (2026-10-29): a Hindi page's
 * og:image:alt and twitter:image:alt were the English line above.
 */
export const SOCIAL_IMAGE_ALT_HI = "ईश्वरम — कुंडली, राशिफल, पंचांग और एआई ज्योतिष";
export const SOCIAL_IMAGE_SIZE = { width: 1200, height: 630 } as const;
/** @internal */
export const SOCIAL_IMAGE_PATH = "/images/ishvaram-social-card.png";
export const OPEN_GRAPH_IMAGE_PATH = SOCIAL_IMAGE_PATH;
export const TWITTER_IMAGE_PATH = SOCIAL_IMAGE_PATH;

/** The shared card's alt for a page in `locale` (Hindi for "hi", English otherwise). */
export function socialImageAlt(locale: string | undefined): string {
  return locale === "hi" ? SOCIAL_IMAGE_ALT_HI : SOCIAL_IMAGE_ALT;
}

/** True for a /hi/ path or a URL whose path is under /hi/. */
export function isHindiPath(pathOrUrl: string): boolean {
  const path = /^https?:\/\//.test(pathOrUrl) ? new URL(pathOrUrl).pathname : pathOrUrl;
  return path === "/hi" || path.startsWith("/hi/");
}
